import React from 'react';


function PersonalData(){

    
    return(
        <div className= 'personal-data-record'>
            <ul className= 'personal-data-list'>
                {/*<img src='./img/personal-pic.jpg' alt={'alfred self pic'}/>*/}
                <li>Alfredo Ricardo Suarez Espinosa</li>
                <li>e-mail.- arse.alf@gmail.com</li>
                <li><a className= 'whatsapp' href='https://wa.link/9ltuga' target='_blank' rel='noreferrer'><img src='https://seeklogo.com/images/W/whatsapp-icon-logo-6E793ACECD-seeklogo.com.png' alt='whats app contact'></img></a></li>
                <a href='https://www.linkedin.com/in/alfredo-ricardo-su%C3%A1rez-espinosa-ab914624/'><li><img src='https://www.mundocuentas.com/wp-content/uploads/2020/11/Linkedin-logo-mundocuentas.jpg' alt='linkedin profile'/></li></a>
                <a href='https://github.com/AlfredoSuarez'><li><img src='https://blog.digital-pineapple.com.mx/wp-content/uploads/2021/06/GitHub_aprender-programacion.jpg' alt='github portfolio'/></li></a>
                <li>Financial managment</li>
                </ul>
        </div>
    )

}

export default PersonalData;